import { options } from '../config/options';
import { rgIDs } from '../../shared/constants/domIDs';
import { messengerV2Url, zoidUrl } from '../../shared/constants/urls';

window.RGMessengerV2Component = window.zoid.create({
  ...options,
  tag: rgIDs.messengerV2,
  url: zoidUrl(messengerV2Url),
});
